<template>
  <div class="h-100 d-flex flex-column align-items-center justify-content-center order-page">
    <div class="mb-1 color-red">Код активиции VIP-статуса будет отправлен вам на e-mail!</div>
    <div class="mb-1">
      <input type="text" :class="{ 'form-control': true, email: true, 'mb-1': true, invalid: !validEmail(email) }"
             placeholder="E-mail" v-model="email" name="email" aria-label="E-mail">
      <div :class="{  'invalid-email-tooltip': true, 'd-none': validEmail(email) && this.email.length > 0 || this.email.length == 0 }" class="">
        Некорректный адрес почты.
      </div>
    </div>
    <div class="mb-1 d-flex">
      <input type="checkbox" :class="{'form-control': true, rules:true, 'mb-1': true, invalid:!rules}" v-model="rules" name="rules" aria-label="Rules">
      <label class="form-check-label" for="rules">Принимаю <a  class="link-rules" @click="$router.push('/rules')">Условия использования</a></label>

    </div>
    <div v-for="(item, index) in priceItems()" :key="`order-${index}`">
      <OneTariff v-bind:price="item.price" v-bind:period="item.count" v-bind:tariffId="item.id"
                 v-bind:payOrder="payOrder" v-bind:showMethods="showMethods"/>
    </div>
  <button type="button" @click="$router.push('/')" class="btn btn-light btn-own mt-2 align-self-center ">
    На главную
  </button>
  </div>
</template>
<script>
import OneTariff from '@/components/OneTariff'
import { mapActions, mapGetters, mapState } from 'vuex'

// /api/side-pricing
export default {
  name: 'FailPayment',
  data () {
    return {
      email: '',
      rules: false,
      boxTwo: ''
    }
  },
  components: { OneTariff },
  computed: {
    ...mapState({
      orders: state => state.orders
    })
  },
  mounted () {
    this.load()

    const emailFromUrl = this.$route.query.email
    if (emailFromUrl) {
      this.email = emailFromUrl
    }
  },
  methods: {
    ...mapActions('pricing', {
      load: 'load',
      makeOrder: 'makeOrder',
      getMehods: 'getMehods'
    }),
    ...mapGetters('pricing', [
      'priceItems'
    ]),
    payOrder: function (id) {
      if (!this.validEmail(this.email) || !this.rules) {
        this.showMsgBoxTwo()
        return
      }
      this.$router.push('/loader')
      this.makeOrder({
        id: id,
        email: this.email
      })
    },
    showMethods: function (id) {
      if (!this.validEmail(this.email) || !this.rules) {
        this.showMsgBoxTwo()
        return
      }
      this.$router.push('/loader')
      this.getMehods({
        id: id,
        email: this.email
      })
    },
    validEmail: function (email) {
      this.email = email.trim()
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    showMsgBoxTwo: function () {
      const text = []
      if (!this.validEmail(this.email)) {
        text.push('Укажите свой e-mail адрес!')
      }
      if (!this.rules) {
        text.push('Прочтите условия использования!')
      }

      this.boxTwo = ''
      this.$bvModal.msgBoxOk(text.join('\n'), {
        title: 'Внимание!',
        size: 'sm',
        buttonSize: 'light',
        // okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-0 border-top-0 justify-content-center ok-btn-modal',
        centered: true
      })
        .then(value => {
          this.boxTwo = value
        })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.link-rules{
  cursor: pointer;
  color: white;
}
.form-check-label{
  margin-left: 10px
}
.order-page input:checked {
  background-color: black;
}
.order-page  .rules{
  width: 30px;
  height: 30px;
}
.email {
  border-radius: 15px;
}

input.invalid {
  border-color: red;
}

@media (max-width: 767px) {
  .email {
    width: 330px;
  }
}

@media (min-width: 767px) {
  .email {
    width: 365px;
  }

  .invalid-email-tooltip {
    position: absolute;
    z-index: 5;
    max-width: 100%;
    padding: 0.25rem 0.5rem;
    margin-top: 0.1rem;
    font-size: 0.875rem;
    color: #fff;
    background-color: rgba(220, 53, 69, 0.9);
    border-radius: 0.25rem;
  }
}
</style>
